module.exports = __webpack_public_path__ + "img/emplacement-reseau.e30a3d3d.png";